<template>
    <modal
      name="IPRolePayTip"
      transition="nice-modal-fade"
      @before-open="beforeOpen"
      :classes="['custom']"
      :clickToClose="false"
      :width="636"
      :height="'auto'"
      :min-height="400"
    >
        <div class="pay-box">
            <div>您的作品中包含{{ filteredIPRoleList.length }}种需要单次付费的IP形象，付费后才能使用。</div>
            <div class="role-list">
              <div
                v-for="(items, index) in filteredIPRoleList.slice(0, 3)"
                :key="index"
                class="role-item"
              >
                <div>
                  <img
                    class="role-size"
                    :src="$handleAssetsUrl(items.thumbnailUrl)"
                  >
                </div>
                <div class="role-price">
                  ￥{{ items.price }}
                </div>
              </div>
              <div
                v-if="filteredIPRoleList.length > 3"
                class="omit"
              >
                ...
              </div>
            </div>
            <div class="btn-box">
              <div
                class="cancel-btn"
                @click="deleteIPRole"
              >删除素材</div>
              <div
                class="confirm-btn"
                @click="goToPay"
              >去付费</div>
            </div>
        </div>
    </modal>
  </template>
  
  <script>
  import { mapGetters } from 'vuex'; 
  export default {
    data () {
      return {
        ipPayList: [],
        filteredIPRoleList: []
      }
    },
    computed: {
      ...mapGetters([
        'TOOL',
        'iframeShown'
      ])
    },
    created () {
  
    },
    methods: {
      // ...mapMutations({
      //   setCharacterStauts: "characterContent/setCharacterStauts",
      // }),
      beforeOpen (ev) {
        console.log(ev.params)
        this.ipPayList = ev.params.ipPayList;
        console.log(`Turbo ~ beforeOpen ~ ipPayList:`, this.ipPayList);
        this.filteredIPRoleList = ev.params.filteredIPRoleList;
        console.log(`Turbo ~ beforeOpen ~ filteredIPRoleList:`, this.filteredIPRoleList);
      },
      async deleteIPRole() {
        // this.setCharacterStauts({ state: false });
        this.$bus.emit('refreshIP');
        this.$bus.emit("loadingAllScenes", "start");
        for (let i = 0; i < this.TOOL.sprites.length; i++) {
          const scenes = this.TOOL.sprites[i];
          console.log(`Turbo ~ deleteIPRole ~ scenes:`, scenes);
          if (scenes.fromJsonLoadingState < 1 && scenes.unLoadData.json) {
            await this.TOOL.selectScenes(scenes);
            await scenes.fromJson(
              scenes.unLoadData.json,
              this.TOOL.clientWidth / scenes.unLoadData.resolutionWidth,
              true
            );
          }
          //初始化一些动画资源
          await scenes.activeAnimation();

          
          const filtered = scenes.sprites.filter(x => {
            return this.ipPayList.some((y) => {
              return y.uuid === x.uuid
            })
          })
          console.log(`Turbo ~ filtered ~ filtered:`, filtered);
          
          if (filtered.length) {
            filtered.forEach(i => {
              this.TOOL.removeSprite(i.uuid, true);
            })
          }
          this.$bus.emit("topnav.saveWorks", {});
          this.$modal.hide('IPRolePayTip');
        }
        this.$bus.emit("loadingAllScenes", "end");
      },
      goToPay() {
        console.log(this.iframeShown);
        let buyId = [];
        this.filteredIPRoleList.forEach((item) => {
          buyId.push(item.uid)
        })
        buyId = buyId.toString();
        console.log(`Turbo ~ goToPay ~ buyId:`, buyId);
        this.$store.commit('set_ipBuyId', buyId);
        this.$modal.hide('IPRolePayTip');
        this.$store.commit('set_iframeShown', true);
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
.pay-box {
    width: 464px;
    height: 294px;
    background: #ffffff;
    border-radius: 4px;
    padding: 48px 32px;
    font-size: 16px;
}
.role-list {
    width: 340px;
    height: 80px;
    margin: 18px 28px 0px;
    display: flex;
    justify-content: center;
    align-content: center;
    .role-item {
        position: relative;
        width: 80px;
        height: 80px;
        background: #F8F8FC;
        margin-right: 10px;
        .role-size {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
        .role-price {
            position: absolute;
            right: 4px;
            top: 4px;
            width: 44px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            background: linear-gradient(270deg, #6464F8 0%, #C064F8 100%);
            border-radius: 4px 4px 4px 4px;
            font-size: 12px;
            color: #ffffff;
        }
    }
    .omit {
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        background: #F8F8FC;
    }
}

.btn-box {
    margin-top: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    .cancel-btn {
        width: 116px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px;
        text-align: center;
        font-size: 14px;
        background: #F2F3F7;
        margin-right: 30px;
        &:hover {
            cursor: pointer;
        }
    }
    .confirm-btn {
        width: 116px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px;
        text-align: center;
        font-size: 14px;
        color: #ffffff;
        background: #6464F8;
        &:hover {
            background: #7979f8;
            cursor: pointer;
        }
    }
}
  </style>
  


// WEBPACK FOOTER //
// src/components/emodal/IPRolePay/IPRolePayTip.vue